module.exports = {"460108001":"海府街道","460108002":"蓝天街道","460108003":"博爱街道","460108004":"海甸街道","460108005":"人民路街道","460108006":"白龙街道","460108007":"和平南街道","460108008":"白沙街道","460108009":"新埠街道","460108101":"灵山镇","460108102":"演丰镇","460108103":"三江镇","460108104":"大致坡镇","460108400":"国营桂林洋农场","460108401":"国营三江农场","460108500":"罗牛山农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460108.json
// module id = 2010
// module chunks = 0